module.exports = __webpack_public_path__ + "media/giftcards/GC-Include-2-2e04dca4.svg";